import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";
import { withTranslation } from "react-i18next";
import { CSS_CLASS_PREFIX } from "../constants/css";
import MaterialIcon from "./MaterialIcon";

const Container = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    font-size: ${p => p.theme.font.sizeSm};
    font-weight: ${p => p.theme.font.weightBold};
    justify-content: space-between;
  }
`;

const NumbersWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    align-items: center;
    display: flex;
    flex: 0 1 0%;
    justify-content: space-between;
  }
`;

const PreviousNextWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    white-space: nowrap;
    flex: 0 1 80px;
    user-select: none;

    * {
      color: ${p => p.theme.pagination.previousNextColor};
      cursor: pointer;
      user-select: none;
    }

    .${CSS_CLASS_PREFIX}-material-icon {
      color: ${p => p.theme.pagination.previousNextColor};
      cursor: pointer;
      user-select: none;
    }
  }

  ${p => cssMainSelector(p.theme.tdsId, { mediaSizeName: 
    "outer-lgphone-down" })} {
    visibility: hidden;
  }
`;

const GapWrapper = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.pagination.gapColor};
  }
`;

const PageWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.pagination.numbersColor};
    cursor: pointer;
    padding: 0 ${p => p.theme.spacing.sm};
    text-align: center;
    user-select: none;

    &.${CSS_CLASS_PREFIX}-selected {
      color: ${p => p.theme.pagination.activeNumberColor};
      cursor: auto;
      user-select: none;
    }
  }
`;

class Pagination extends PureComponent {
  render() {
    const { currentPage, onPageClick, t, totalPages } = this.props;

    return (
      <Container>
        <PreviousNextWrapper onClick={onPageClick.bind(this, currentPage - 1)}>
          {currentPage > 1 && (
            <span>
              <MaterialIcon>chevron_left</MaterialIcon> {t("previous")}
            </span>
          )}
        </PreviousNextWrapper>
        <NumbersWrapper>{this.numberList()}</NumbersWrapper>
        <PreviousNextWrapper onClick={onPageClick.bind(this, currentPage + 1)}>
          {currentPage !== totalPages && (
            <span>
              {t("next")} <MaterialIcon>chevron_right</MaterialIcon>
            </span>
          )}
        </PreviousNextWrapper>
      </Container>
    );
  }

  numberList() {
    const { currentPage, onPageClick, totalPages } = this.props;
    let pages = [];
    let gapSet = false;

    for (let i = 1; i <= totalPages; i += 1) {
      let className = "";

      if (i === currentPage) {
        className = `${CSS_CLASS_PREFIX}-selected`;
      }

      if (
        i > 2 &&
        i < totalPages - 2 &&
        (i < currentPage - 1 || i > currentPage + 1)
      ) {
        if (!gapSet) {
          // add gap in front of this element
          pages.push(<GapWrapper key={i}>...</GapWrapper>);

          gapSet = true;
        }
      } else {
        pages.push(
          <PageWrapper
            key={i}
            onClick={onPageClick.bind(this, i)}
            className={className}
          >
            {i}
          </PageWrapper>
        );

        gapSet = false;
      }
    }

    return pages;
  }
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  onPageClick: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired
};

export default withTranslation(["pagination"])(Pagination);
